import { render, staticRenderFns } from "./SvgLayersModal.vue?vue&type=template&id=4bb3b424&scoped=true"
import script from "./SvgLayersModal.vue?vue&type=script&lang=js"
export * from "./SvgLayersModal.vue?vue&type=script&lang=js"
import style0 from "./SvgLayersModal.vue?vue&type=style&index=0&id=4bb3b424&scoped=true&lang=css"
import style1 from "./SvgLayersModal.vue?vue&type=style&index=1&id=4bb3b424&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb3b424",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_testing/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4bb3b424')) {
      api.createRecord('4bb3b424', component.options)
    } else {
      api.reload('4bb3b424', component.options)
    }
    module.hot.accept("./SvgLayersModal.vue?vue&type=template&id=4bb3b424&scoped=true", function () {
      api.rerender('4bb3b424', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/svg-editor/SvgLayersModal.vue"
export default component.exports